import { render, staticRenderFns } from "./PdfViewerPaginator.vue?vue&type=template&id=4f954cda&scoped=true&"
import script from "./PdfViewerPaginator.vue?vue&type=script&lang=ts&"
export * from "./PdfViewerPaginator.vue?vue&type=script&lang=ts&"
import style0 from "./PdfViewerPaginator.vue?vue&type=style&index=0&id=4f954cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f954cda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})
